class TSSChickenQuickPersonalizer extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.media = this.querySelector('.tss-qp__media');
    this.info = this.querySelector('.tss-qp__info');
    this.mediaHome = document.createComment('tss-quick-personalizer-media-home');
    if (this.media?.parentNode) this.media.parentNode.insertBefore(this.mediaHome, this.media);
    this.preview = this.querySelector('[data-qp-preview]');
    this.previewWrap = this.querySelector('.tss-qp__preview-wrap');
    this.previewText = this.querySelector('[data-qp-preview-text]');
    this.textInput = this.querySelector('[data-qp-text]');
    this.customizeToggle = this.querySelector('[data-qp-customize-toggle]');
    this.customTextField = this.querySelector('[data-qp-custom-text-field]');
    this.customizationProperty = this.querySelector('[data-qp-customization-property]');
    this.originalDesignLabel = this.dataset.originalDesignLabel || 'Original design';
    this.customDesignLabel = this.dataset.customDesignLabel || 'Customized text';
    this.forceUppercase = this.dataset.forceUppercase !== 'false';
    this.maxTextWidthPct = Math.max(35, Math.min(98, Number(this.dataset.textMaxWidth || 90)));
    this.startTextHeightPct = Math.max(10, Math.min(85, Number(this.dataset.textHeight || 54)));
    this.textYPct = Math.max(10, Math.min(90, Number(this.dataset.textY || 50)));
    this.letterSpacing = Math.max(-10, Math.min(25, Number(this.dataset.letterSpacing || 0)));
    this.letterFillStrength = Math.max(0, Math.min(10, Number(this.dataset.letterFill || 5)));
    this.chickenFontFamily = this.dataset.chickenFontFamily || 'TSSChickenFont';
    this.chickenFontUrl = this.dataset.chickenFontUrl || '';
    this.textEntryField = this.textInput?.closest('.tss-qp__field');
    this.textOptionsPanel = this.querySelector('.tss-qp__text-options-panel');
    this.fontGroup = this.querySelector('[data-qp-font-group]');
    this.count = this.querySelector('[data-qp-count]');
    this.quantity = this.querySelector('[data-qp-quantity]');
    this.unitPrice = this.querySelector('[data-qp-unit-price]');
    this.totalPrice = this.querySelector('[data-qp-total-price]');
    this.tierMessage = this.querySelector('[data-qp-tier-message]');
    this.doubleSided = this.querySelector('[data-qp-double]');
    this.textColor = this.querySelector('[data-qp-text-color]');
    this.approval = this.querySelector('[data-qp-approval]');
    this.submit = this.querySelector('[data-qp-submit]');
    this.mobileCart = this.querySelector('[data-qp-mobile-cart]');
    this.approvalWrap = this.querySelector('[data-qp-approval-wrap]');
    this.proofCard = this.querySelector('[data-qp-proof-card]');
    this.proofPreview = this.querySelector('[data-qp-proof-preview]');
    this.backgroundUrl = this.dataset.backgroundUrl || '';
    this.originalBackgroundUrl = this.dataset.originalBackgroundUrl || '';
    this.stageEndpoint = this.dataset.printStageEndpoint || '';
    this.finalizeEndpoint = this.dataset.printFinalizeEndpoint || '';
    this.galleryEndpoint = (this.dataset.galleryEndpoint || '').replace(/\/$/, '');
    this.assistanceEndpoint = this.dataset.assistanceEndpoint || '';
    this.galleryDialog = this.querySelector('[data-qp-gallery-dialog]');
    this.galleryForm = this.querySelector('[data-qp-gallery-form]');
    this.imageDialog = this.querySelector('[data-qp-image-dialog]');
    this.helpDialog = this.querySelector('[data-qp-help-dialog]');
    this.helpForm = this.querySelector('[data-qp-help-form]');
    this.enableText = this.dataset.enableText !== 'false';
    this.requireText = this.enableText && this.dataset.requireText !== 'false';
    this.requireHoles = this.dataset.requireHoles !== 'false';
    this.requireApproval = this.dataset.requireApproval !== 'false';
    this.assetsReady = false;
    this.isSubmitting = false;
    this.variantAvailable = true;
    this.textScale = 1;
    this.allCaps = this.forceUppercase;
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.variantData = JSON.parse(this.querySelector('[data-qp-variants]').textContent || '[]');
    this.bind();
    this.buildFontChoices();
    this.setupMobileStepAccordion();
    this.restoreDesign();
    if (window.matchMedia('(max-width: 700px)').matches) this.querySelector('[data-qp-advanced]')?.removeAttribute('open');
    this.syncAll();
    const initialVariant = this.querySelector('[data-qp-variant]')?.value;
    if (initialVariant) this.syncVariant(initialVariant);
    this.hideLegacyOptions();
    this.loadCustomerGallery();
    this.legacyScope = this.closest('.shopify-section') || this.parentElement || this;
    this.legacyObserver = new MutationObserver(() => this.hideLegacyOptions());
    this.legacyObserver.observe(this.legacyScope, { childList:true, subtree:true });
    this.resizeObserver = new ResizeObserver(() => { this.fitText(); if (this.currentDimensions) this.updateHoleGeometry(this.currentDimensions.height, this.currentDimensions.width); });
    this.resizeObserver.observe(this.preview);
    document.fonts?.ready?.then(() => this.fitText());
    this.loadChickenFont();
    this.updateMobileCartVisibility();
    this.syncMobileLayout();
    this.updateStepButtons();
    this.updateMobileProgress();
    this.updateRequiredNotice();
  }

  hideLegacyOptions() {
    const scope = this.legacyScope || this.closest('.shopify-section') || this;
    const matchers = [
      /^Size\b/i,
      /^Font\b/i,
      /^Your custom text here\s*\*?$/i,
      /^Holes?\b/i,
      /^Would you like a preview before production\??$/i
    ];
    const labels = [...scope.querySelectorAll('label, legend')].filter((label) => {
      if (label.closest('tss-chicken-personalizer')) return false;
      const text = (label.textContent || '').replace(/\s+/g, ' ').trim();
      return matchers.some((pattern) => pattern.test(text));
    });

    // Only act when the injected app's distinctive option set is present.
    // This prevents an ordinary Shopify Size or Font picker from being hidden.
    const hasAppFingerprint = labels.some((label) => /your custom text here|preview before production/i.test(label.textContent || ''));
    if (!hasAppFingerprint) return;

    labels.forEach((label) => {
      let group = label.closest('.product-form__input,.form__field,.product-customizer-option,.option-field,.field,.gpo-element,.globo-form-control,.product-options__option');
      if (!group) {
        group = label.parentElement;
        while (group && group.parentElement !== scope && !group.querySelector('input,select,textarea,button')) group = group.parentElement;
      }
      if (group && group !== this && group !== this.form) {
        group.hidden = true;
        group.setAttribute('data-qp-legacy-hidden', 'true');
      }
    });
  }

  bind() {
    this.customizeToggle?.addEventListener('change', () => {
      this.syncCustomizationMode();
      this.validateForm();
      this.saveDesign();
    });
    this.textInput?.addEventListener('input', () => { this.syncText(); this.validateForm(); this.saveDesign(); });
    this.textInput?.addEventListener('focus', () => this.keepFieldVisible(this.textInput));
    this.querySelector('[data-qp-font]')?.addEventListener('change', () => { this.syncFont(); this.updateFontChoices(); this.validateForm(); this.saveDesign(); });
    this.querySelector('[data-qp-caps]')?.addEventListener('click', (event) => this.toggleCaps(event.currentTarget));
    this.querySelectorAll('[data-qp-text-size]').forEach((button) => button.addEventListener('click', () => this.adjustTextSize(Number(button.dataset.qpTextSize))));
    this.querySelector('[data-qp-spacing]')?.addEventListener('input', (event) => this.setLetterSpacing(Number(event.target.value)));
    this.textColor?.addEventListener('input', (event) => { this.setTextColor(event.target.value); this.saveDesign(); });
    this.querySelector('[data-qp-holes]')?.addEventListener('change', () => { this.syncHoles(); this.validateForm(); this.updateStepButtons(); this.saveDesign(); });
    this.doubleSided?.addEventListener('change', () => { this.syncDoubleSided(); this.syncPrice(); this.saveDesign(); });
    this.querySelectorAll('[data-qp-review-scroll]').forEach((button) => button.addEventListener('click', () => {
      const track = this.querySelector('[data-qp-review-track]');
      if (!track) return;
      track.scrollBy({ left:Number(button.dataset.qpReviewScroll) * track.clientWidth * .9, behavior:'smooth' });
    }));
    this.querySelectorAll('[data-qp-gallery-open]').forEach((button) => button.addEventListener('click', () => this.openGalleryForm()));
    this.querySelectorAll('[data-qp-gallery-close]').forEach((button) => button.addEventListener('click', () => this.closeGalleryForm()));
    this.galleryDialog?.addEventListener('click', (event) => { if (event.target === this.galleryDialog) this.closeGalleryForm(); });
    this.querySelectorAll('[data-qp-image-open]').forEach((button) => button.addEventListener('click', () => this.openProductImage(button)));
    this.querySelector('[data-qp-image-close]')?.addEventListener('click', () => this.closeProductImage());
    this.imageDialog?.addEventListener('click', (event) => { if (event.target === this.imageDialog) this.closeProductImage(); });
    this.querySelector('[data-qp-gallery-file]')?.addEventListener('change', (event) => this.previewGalleryPhoto(event.target.files?.[0]));
    this.galleryForm?.addEventListener('submit', (event) => this.submitGalleryPhoto(event));
    this.querySelector('[data-qp-help-open]')?.addEventListener('click', () => this.openHelpForm());
    this.querySelectorAll('[data-qp-help-close]').forEach((button) => button.addEventListener('click', () => this.closeHelpForm()));
    this.helpDialog?.addEventListener('click', (event) => { if (event.target === this.helpDialog) this.closeHelpForm(); });
    this.helpForm?.addEventListener('submit', (event) => this.submitHelpForm(event));
    this.querySelector('[data-qp-variant]')?.addEventListener('change', (event) => { this.syncVariant(event.target.value); this.updateStepButtons(); this.saveDesign(); });
    this.querySelectorAll('[data-qp-qty-change]').forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(1, Number(this.quantity.value || 1) + Number(button.dataset.qpQtyChange));
      this.quantity.value = next;
      this.syncPrice();
      this.validateForm();
      this.updateStepButtons();
      this.saveDesign();
    }));
    this.quantity?.addEventListener('change', () => { this.quantity.value = Math.max(1, Number(this.quantity.value || 1)); this.syncPrice(); this.validateForm(); this.updateStepButtons(); this.saveDesign(); });
    this.approval?.addEventListener('change', () => { this.approvalWrap?.classList.toggle('is-approved', this.approval.checked); this.validateForm(); this.updateMobileProgress(); this.updateRequiredNotice(); });
    this.querySelector('[name="properties[Notes/Format Requests]"]')?.addEventListener('input', () => this.saveDesign());
    this.querySelector('[data-qp-tier-toggle]')?.addEventListener('click', (event) => {
      const bulk = event.currentTarget.closest('.tss-qp__bulk');
      const expanded = bulk?.classList.toggle('is-expanded');
      event.currentTarget.setAttribute('aria-expanded', String(Boolean(expanded)));
      event.currentTarget.textContent = expanded ? 'Hide bulk discounts' : 'Learn more about bulk discounts';
    });
    this.querySelector('[data-qp-show-products]')?.addEventListener('click', (event) => {
      const section = event.currentTarget.closest('.tss-qp__recommendations');
      const expanded = section?.classList.toggle('is-expanded');
      event.currentTarget.setAttribute('aria-expanded', String(Boolean(expanded)));
      event.currentTarget.textContent = expanded ? 'Show fewer products' : 'Show more products';
    });
    this.querySelector('[data-qp-mobile-submit]')?.addEventListener('click', () => {
      if (!this.validateForm(true)) return;
      if (this.requireApproval && !this.approval?.checked) this.querySelector('[data-qp-order-review]')?.scrollIntoView({ behavior:'smooth', block:'start' });
      else this.handleAddToCart();
    });
    window.addEventListener('resize', () => { this.updateMobileCartVisibility(); this.syncMobileLayout(); this.syncMobileStepAccordion(); }, { passive:true });
    window.addEventListener('scroll', () => this.updateMobileProgress(), { passive:true });
    this.submit?.addEventListener('click', () => {
      this.handleAddToCart();
    });
    this.form?.addEventListener('submit', (event) => {
      if (!this.validateForm(true)) { event.preventDefault(); return; }
      if (this.isCustomized() && !this.assetsReady) { event.preventDefault(); this.handleAddToCart(); return; }
      const fontSelect = this.querySelector('[data-qp-font]');
      const selectedFont = fontSelect?.selectedOptions?.[0];
      const fontProp = this.querySelector('[data-qp-font-property]');
      const sizeProp = this.querySelector('[data-qp-size-property]');
      const capsProp = this.querySelector('[data-qp-caps-property]');
      const spacingProp = this.querySelector('[data-qp-spacing-property]');
      if (fontProp) fontProp.value = this.isCustomized() ? (selectedFont?.dataset.label || 'Chicken listing font') : 'Original artwork';
      if (sizeProp) sizeProp.value = this.isCustomized() ? 'Automatic fit' : 'Original artwork';
      if (capsProp) capsProp.value = this.isCustomized() ? (this.forceUppercase ? 'ALL CAPS' : 'As entered') : 'Original artwork';
      if (spacingProp) spacingProp.value = this.isCustomized() ? `${this.letterSpacing}%` : 'Original artwork';
      if (this.customizationProperty) this.customizationProperty.value = this.isCustomized() ? this.customDesignLabel : this.originalDesignLabel;
    });
  }

  buildFontChoices() {
    const select = this.querySelector('[data-qp-font]');
    const container = this.querySelector('[data-qp-font-choices]');
    if (!select || !container) return;
    container.replaceChildren(...[...select.options].map((option, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tss-qp__font-choice';
      button.dataset.value = option.value;
      button.style.fontFamily = option.value;
      const sample = document.createElement('span');
      const label = document.createElement('small');
      sample.textContent = 'Abc';
      label.textContent = option.dataset.label || option.textContent.trim();
      button.append(sample, label);
      button.setAttribute('aria-pressed', String(option.selected));
      button.addEventListener('click', () => {
        select.selectedIndex = index;
        select.dispatchEvent(new Event('change', { bubbles:true }));
      });
      return button;
    }));
    this.updateFontChoices();
  }

  updateFontChoices() {
    const value = this.querySelector('[data-qp-font]')?.value;
    this.querySelectorAll('[data-qp-font-choices] button').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.value === value));
    });
  }

  setupMobileStepAccordion() {
    if (!this.form || this.mobileSteps?.length) return;
    const directChildren = [...this.form.children].filter((element) => element.matches?.('.tss-qp__field:not(.tss-qp__notes-field)') && !element.hidden);
    this.mobileSteps = directChildren.map((element, index) => {
      if (element.matches('.tss-qp__advanced')) {
        element.classList.add('tss-qp__mobile-step');
        element.dataset.qpMobileStep = String(index + 1);
        return element;
      }
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const title = document.createElement('span');
      details.className = 'tss-qp__mobile-step';
      details.dataset.qpMobileStep = String(index + 1);
      title.textContent = element.querySelector('.tss-qp__label, .tss-qp__legend')?.textContent?.replace(/\s+/g, ' ').trim() || `Step ${index + 1}`;
      summary.append(title);
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'tss-qp__step-next';
      next.dataset.qpStepNext = String(index);
      next.textContent = index === directChildren.length - 1 ? 'Next: Review your sign' : 'Next';
      next.addEventListener('click', () => this.goToNextStep(index));
      element.before(details);
      details.append(summary, element, next);
      return details;
    });
    this.mobileSteps.forEach((step) => step.addEventListener('toggle', () => {
      if (!step.open || !window.matchMedia('(max-width: 700px)').matches) return;
      this.mobileSteps.forEach((other) => { if (other !== step) other.open = false; });
    }));
    this.syncMobileStepAccordion(true);
  }

  stepIsComplete(index) {
    if (index === 0) return Boolean(this.querySelector('[data-qp-variant]')?.value);
    if (index === 1) return !this.isCustomized() || Boolean(this.textInput?.value.trim());
    const holesEl = this.querySelector('[data-qp-holes]');
    const holesVisible = Boolean(holesEl && !holesEl.closest('.tss-qp__field')?.hidden);
    const holesIndex = holesVisible ? 2 : -1;
    const qtyIndex = holesVisible ? 3 : 2;
    if (index === holesIndex) return !this.requireHoles || Boolean(this.querySelector('[data-qp-holes]')?.value);
    if (index === qtyIndex) return Number(this.quantity?.value || 0) >= 1;
    return true;
  }

  updateStepButtons() {
    this.mobileSteps?.forEach((step, index) => {
      const button = step.querySelector('[data-qp-step-next]');
      if (button) button.disabled = !this.stepIsComplete(index);
    });
  }

  goToNextStep(index) {
    if (!this.stepIsComplete(index)) return;
    const next = this.mobileSteps?.[index + 1];
    if (next) {
      next.open = true;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const previewHeight = this.media?.offsetHeight || 0;
        const top = next.getBoundingClientRect().top + window.scrollY - previewHeight - 8;
        window.scrollTo({ top:Math.max(0, top), behavior:'smooth' });
      }));
      return;
    }
    this.querySelector('[data-qp-order-review]')?.scrollIntoView({ behavior:'smooth', block:'start' });
  }

  openRequiredTarget(target) {
    if (target === 'approval') {
      this.approvalWrap?.scrollIntoView({ behavior:'smooth', block:'center' });
      return;
    }
    const step = this.mobileSteps?.[Number(target)];
    if (!step) return;
    step.open = true;
    requestAnimationFrame(() => {
      const previewHeight = window.matchMedia('(max-width: 700px)').matches ? (this.media?.offsetHeight || 0) : 0;
      const top = step.getBoundingClientRect().top + window.scrollY - previewHeight - 8;
      window.scrollTo({ top:Math.max(0, top), behavior:'smooth' });
    });
  }

  getMissingRequirements() {
    const missing = [];
    if (!this.querySelector('[data-qp-variant]')?.value) missing.push({ label:'Choose a size', target:0 });
    if (this.isCustomized() && !this.textInput?.value.trim()) missing.push({ label:'Enter your custom wording', target:1 });
    const holesEl = this.querySelector('[data-qp-holes]');
    const holesVisible = Boolean(holesEl && !holesEl.closest('.tss-qp__field')?.hidden);
    const holesTarget = holesVisible ? 2 : -1;
    const qtyTarget = holesVisible ? 3 : 2;
    if (this.requireHoles && !this.querySelector('[data-qp-holes]')?.value) missing.push({ label:'Choose hole placement', target:holesTarget });
    if (Number(this.quantity?.value || 0) < 1) missing.push({ label:'Choose a quantity', target:qtyTarget });
    return missing;
  }

  updateRequiredNotice() {
    const notice = this.querySelector('[data-qp-required-notice]');
    const list = this.querySelector('[data-qp-required-list]');
    if (!notice || !list) return;
    const missing = this.getMissingRequirements();
    notice.hidden = missing.length === 0;
    list.replaceChildren(...missing.map((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = item.label;
      button.addEventListener('click', () => this.openRequiredTarget(item.target));
      return button;
    }));
  }

  syncMobileStepAccordion(initial = false) {
    if (!this.mobileSteps?.length) return;
    const mobile = window.matchMedia('(max-width: 700px)').matches;
    if (!mobile) {
      this.mobileSteps.forEach((step) => { step.open = true; });
      return;
    }
    if (initial || !this.mobileSteps.some((step) => step.open)) {
      this.mobileSteps.forEach((step, index) => { step.open = index === 0; });
    } else {
      let foundOpen = false;
      this.mobileSteps.forEach((step) => {
        if (step.open && !foundOpen) foundOpen = true;
        else if (step.open) step.open = false;
      });
    }
  }

  keepFieldVisible(field) {
    if (!window.matchMedia('(max-width: 700px)').matches) return;
    window.setTimeout(() => field.scrollIntoView({ behavior:'smooth', block:'center' }), 300);
  }

  getStorageKey() { return `tss-chicken-personalizer:${this.dataset.productHandle || location.pathname}`; }
  saveDesign() {
    clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => {
      try {
        localStorage.setItem(this.getStorageKey(), JSON.stringify({
          variant:this.querySelector('[data-qp-variant]')?.value,
          text:this.textInput?.value || '',
          customize:Boolean(this.customizeToggle?.checked),
          font:this.querySelector('[data-qp-font]')?.value,
          holes:this.querySelector('[data-qp-holes]')?.value,
          quantity:this.quantity?.value || '1',
          notes:this.querySelector('[name="properties[Notes/Format Requests]"]')?.value || '',
          caps:this.allCaps,
          textScale:this.textScale,
          spacing:this.letterSpacing,
          textColor:this.textColor?.value || '#1c1c1c',
          doubleSided:Boolean(this.doubleSided?.checked)
        }));
      } catch (_error) {}
    }, 250);
  }
  restoreDesign() {
    try {
      const saved = JSON.parse(localStorage.getItem(this.getStorageKey()) || 'null');
      if (!saved) return;
      const variant = this.querySelector('[data-qp-variant]');
      const font = this.querySelector('[data-qp-font]');
      const holes = this.querySelector('[data-qp-holes]');
      const notes = this.querySelector('[name="properties[Notes/Format Requests]"]');
      if (variant && [...variant.options].some((item) => item.value === saved.variant)) variant.value = saved.variant;
      if (this.textInput) this.textInput.value = saved.text || '';
      if (this.customizeToggle) this.customizeToggle.checked = Boolean(saved.customize);
      if (font && [...font.options].some((item) => item.value === saved.font)) font.value = saved.font;
      if (holes && [...holes.options].some((item) => item.value === saved.holes)) holes.value = saved.holes;
      if (this.quantity) this.quantity.value = Math.max(1, Number(saved.quantity || 1));
      if (notes) notes.value = saved.notes || '';
      this.allCaps = this.forceUppercase;
      this.textScale = 1;
      this.letterSpacing = Math.max(-10, Math.min(25, Number(this.dataset.letterSpacing || 0)));
      const caps = this.querySelector('[data-qp-caps]');
      caps?.classList.toggle('active', this.allCaps);
      caps?.setAttribute('aria-pressed', String(this.allCaps));
      const scaleLabel = this.querySelector('[data-qp-text-size-label]');
      if (scaleLabel) scaleLabel.textContent = `${Math.round(this.textScale * 100)}%`;
      const spacing = this.querySelector('[data-qp-spacing]');
      if (spacing) spacing.value = String(this.letterSpacing);
      if (this.textColor && /^#[0-9a-f]{6}$/i.test(saved.textColor || '')) this.textColor.value = saved.textColor;
      if (this.doubleSided) this.doubleSided.checked = Boolean(saved.doubleSided);
      this.updateFontChoices();
    } catch (_error) {}
  }

  updateReview() {
    const value = (selector) => this.querySelector(selector);
    const variant = value('[data-qp-variant]')?.selectedOptions?.[0]?.textContent?.split('—')[0]?.trim() || '—';
    const text = this.isCustomized() ? (this.textInput?.value.trim() || 'Enter your wording above') : this.originalDesignLabel;
    const quantity = Math.max(1, Number(this.quantity?.value || 1));
    const total = value('[data-qp-total-price]')?.value || '';
    const pairs = {
      '[data-qp-review-size]':variant,
      '[data-qp-review-text]':text,
      '[data-qp-review-holes]':value('[data-qp-holes]')?.value || 'No holes selected',
      '[data-qp-review-printing]':this.doubleSided?.checked?'Double-sided':'Single-sided',
      '[data-qp-review-quantity]':String(quantity),
      '[data-qp-review-total]':total
    };
    Object.entries(pairs).forEach(([selector, content]) => { const target = value(selector); if (target) target.textContent = content; });
    const mode = value('[data-qp-review-mode]');
    if (mode) mode.textContent = this.isCustomized() ? this.customDesignLabel : this.originalDesignLabel;
    const mobileTotal = value('[data-qp-mobile-total]');
    if (mobileTotal) mobileTotal.textContent = total;
  }

  updateMobileCartVisibility() {
    if (!this.mobileCart) return;
    this.mobileCart.hidden = !window.matchMedia('(max-width: 700px)').matches;
  }

  syncMobileLayout() {
    if (!this.media || !this.info) return;
    const mobile = window.matchMedia('(max-width: 700px)').matches;
    const card = this.info.querySelector('.tss-qp__card');
    if (mobile) {
      if (this.media.parentNode !== this.info) this.info.insertBefore(this.media, card || this.info.firstChild);
      if (this.fontGroup && this.textEntryField && this.fontGroup.parentNode !== this.textEntryField) this.textEntryField.append(this.fontGroup);
    } else if (this.mediaHome?.parentNode && this.media.parentNode !== this.mediaHome.parentNode) {
      this.mediaHome.parentNode.insertBefore(this.media, this.mediaHome.nextSibling);
      if (this.fontGroup && this.textOptionsPanel && this.fontGroup.parentNode !== this.textOptionsPanel) this.textOptionsPanel.insertBefore(this.fontGroup, this.textOptionsPanel.querySelector('.tss-qp__text-tools'));
    } else if (!mobile && this.fontGroup && this.textOptionsPanel && this.fontGroup.parentNode !== this.textOptionsPanel) {
      this.textOptionsPanel.insertBefore(this.fontGroup, this.textOptionsPanel.querySelector('.tss-qp__text-tools'));
    }
    requestAnimationFrame(() => { this.fitText(); if (this.currentDimensions) this.updateHoleGeometry(this.currentDimensions.height, this.currentDimensions.width); });
  }

  updateMobileProgress() {
    if (!window.matchMedia('(max-width: 700px)').matches) return;
    const formRect = this.form?.getBoundingClientRect();
    this.classList.toggle('is-mobile-editing', Boolean(formRect && formRect.top < 80 && formRect.bottom > 330));
    const review = this.querySelector('[data-qp-order-review]');
    let stage = review && review.getBoundingClientRect().top < innerHeight * .72 ? 'review' : 'design';
    if (this.approval?.checked) stage = 'cart';
    this.querySelectorAll('[data-qp-progress]').forEach((item) => item.classList.toggle('is-current', item.dataset.qpProgress === stage));
    const mobileButton = this.querySelector('[data-qp-mobile-submit]');
    if (mobileButton) mobileButton.textContent = this.approval?.checked || !this.requireApproval ? (this.submit?.dataset.availableText || 'Add to cart') : 'Review & add to cart';
  }

  openGalleryForm() {
    if (!this.galleryDialog) return;
    if (typeof this.galleryDialog.showModal === 'function') this.galleryDialog.showModal();
    else this.galleryDialog.setAttribute('open', '');
  }

  openProductImage(button) {
    const image = this.querySelector('[data-qp-image-large]');
    if (!this.imageDialog || !image) return;
    image.src = button.dataset.imageSrc || button.querySelector('img')?.src || '';
    image.alt = button.dataset.imageAlt || '';
    if (typeof this.imageDialog.showModal === 'function') this.imageDialog.showModal();
    else this.imageDialog.setAttribute('open', '');
  }

  closeProductImage() {
    if (!this.imageDialog) return;
    if (typeof this.imageDialog.close === 'function') this.imageDialog.close();
    else this.imageDialog.removeAttribute('open');
  }

  closeGalleryForm() {
    if (!this.galleryDialog) return;
    if (typeof this.galleryDialog.close === 'function') this.galleryDialog.close();
    else this.galleryDialog.removeAttribute('open');
  }

  openHelpForm() {
    if (!this.helpDialog) return;
    if (typeof this.helpDialog.showModal === 'function') this.helpDialog.showModal();
    else this.helpDialog.setAttribute('open', '');
  }

  closeHelpForm() {
    if (!this.helpDialog) return;
    if (typeof this.helpDialog.close === 'function') this.helpDialog.close();
    else this.helpDialog.removeAttribute('open');
  }

  async submitHelpForm(event) {
    event.preventDefault();
    if (!this.helpForm?.reportValidity()) return;
    const submit = this.querySelector('[data-qp-help-submit]');
    const status = this.querySelector('[data-qp-help-status]');
    const file = this.querySelector('[data-qp-help-file]')?.files?.[0];
    if (file && file.size > 10 * 1024 * 1024) {
      if (status) status.textContent = 'Please choose a file smaller than 10 MB.';
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Sending request…';
    if (status) status.textContent = '';
    try {
      const fields = new FormData(this.helpForm);
      fields.append('product', this.dataset.productHandle || document.title);
      fields.append('page_url', location.href);
      fields.append('current_selected_size', this.querySelector('[data-qp-variant]')?.selectedOptions?.[0]?.textContent?.trim() || 'Not selected');
      const response = await fetch(this.assistanceEndpoint, { method:'POST', headers:{ Accept:'application/json' }, body:fields });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.success === false) throw new Error(data.message || 'Your request could not be sent. Please try again.');
      this.querySelector('[data-qp-help-form-wrap]').hidden = true;
      this.querySelector('[data-qp-help-success]').hidden = false;
      this.helpForm.reset();
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Send design request';
    }
  }

  previewGalleryPhoto(file) {
    const preview = this.querySelector('[data-qp-gallery-preview]');
    if (!preview || !file) return;
    if (this.galleryPreviewUrl) URL.revokeObjectURL(this.galleryPreviewUrl);
    this.galleryPreviewUrl = URL.createObjectURL(file);
    preview.src = this.galleryPreviewUrl;
    preview.hidden = false;
  }

  async loadCustomerGallery() {
    const loading = this.querySelector('[data-qp-gallery-loading]');
    const container = this.querySelector('[data-qp-gallery-dynamic]');
    if (!this.galleryEndpoint || !container) { if (loading) loading.hidden = true; return; }
    try {
      const response = await fetch(`${this.galleryEndpoint}/api/gallery`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Gallery unavailable');
      for (const photo of (data.photos || [])) {
        const card = document.createElement(photo.productUrl ? 'a' : 'div');
        card.className = 'tss-qp__gallery-photo';
        if (photo.productUrl) card.href = photo.productUrl;
        const image = document.createElement('img');
        image.src = photo.photoUrl;
        image.alt = `${photo.name || 'Customer'}’s sign on display`;
        image.loading = 'lazy';
        const name = document.createElement('span');
        name.textContent = photo.name || 'Customer photo';
        card.append(image, name);
        container.append(card);
      }
    } catch (_error) {
      // The invitation tile remains usable even if approved photos cannot load.
    } finally {
      if (loading) loading.hidden = true;
    }
  }

  async optimizeGalleryPhoto(file) {
    if (!file || !/^image\/(jpeg|png|webp)$/.test(file.type)) throw new Error('Please choose a JPG, PNG, or WebP image.');
    const image = await createImageBitmap(file);
    const scale = Math.min(1, 1800 / Math.max(image.width, image.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
    image.close?.();
    return canvas.toDataURL('image/jpeg', .82);
  }

  async submitGalleryPhoto(event) {
    event.preventDefault();
    if (!this.galleryForm?.reportValidity()) return;
    const submit = this.querySelector('[data-qp-gallery-submit]');
    const status = this.querySelector('[data-qp-gallery-status]');
    const file = this.querySelector('[data-qp-gallery-file]')?.files?.[0];
    submit.disabled = true;
    submit.textContent = 'Preparing your photo…';
    if (status) status.textContent = '';
    try {
      const photoDataUrl = await this.optimizeGalleryPhoto(file);
      submit.textContent = 'Submitting securely…';
      const fields = new FormData(this.galleryForm);
      const response = await fetch(`${this.galleryEndpoint}/api/submit`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          photoDataUrl,
          firstName:String(fields.get('firstName') || '').trim(),
          lastInitial:String(fields.get('lastInitial') || '').trim(),
          email:String(fields.get('email') || '').trim(),
          marketingConsent:Boolean(fields.get('marketingConsent')),
          shareConsent:Boolean(fields.get('shareConsent'))
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Your photo could not be submitted. Please try again.');
      this.querySelector('[data-qp-gallery-form-wrap]').hidden = true;
      this.querySelector('[data-qp-gallery-success]').hidden = false;
      this.galleryForm.reset();
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Submit photo & get 25% off';
    }
  }

  toggleCaps(button) {
    this.allCaps = !this.allCaps;
    button?.setAttribute('aria-pressed', this.allCaps ? 'true' : 'false');
    button?.classList.toggle('active', this.allCaps);
    this.syncText();
    this.scheduleProofPreview();
    this.saveDesign();
  }

  adjustTextSize(direction) {
    this.textScale = Math.max(.55, Math.min(1.08, this.textScale + direction * .05));
    const label = this.querySelector('[data-qp-text-size-label]');
    if (label) label.textContent = `${Math.round(this.textScale * 100)}%`;
    this.fitText();
    this.scheduleProofPreview();
    this.saveDesign();
  }

  setLetterSpacing(value) {
    this.letterSpacing = Math.max(0, Math.min(20, value));
    this.previewText.style.letterSpacing = `${this.letterSpacing / 100}em`;
    const label = this.querySelector('[data-qp-spacing-label]');
    if (label) label.textContent = `${this.letterSpacing}%`;
    this.fitText();
    this.scheduleProofPreview();
    this.saveDesign();
  }

  validateForm(showErrors = false) {
    const textValid = !this.isCustomized() || Boolean(this.textInput?.value.trim());
    const holesValid = !this.requireHoles || Boolean(this.querySelector('[data-qp-holes]')?.value);
    const quantityValid = Number(this.quantity?.value || 0) >= 1;
    const approvalValid = !this.requireApproval || Boolean(this.approval?.checked);
    const valid = textValid && holesValid && quantityValid && approvalValid && this.variantAvailable;
    this.updateRequiredNotice();
    this.submit?.setAttribute('aria-disabled', valid ? 'false' : 'true');
    if (valid) {
      this.customTextField?.classList.remove('is-invalid');
      const status = this.querySelector('.tss-qp__status');
      if (status) status.textContent = '';
    }
    if (showErrors) {
      this.customTextField?.classList.toggle('is-invalid', !textValid);
      if (!textValid && this.textInput) {
        this.textInput.focus({ preventScroll:true });
        this.textInput.scrollIntoView({ behavior:'smooth', block:'center' });
      } else if (this.requireHoles && !holesValid) {
        const holes = this.querySelector('[data-qp-holes]');
        holes?.focus({ preventScroll:true });
        holes?.scrollIntoView({ behavior:'smooth', block:'center' });
      } else if (this.requireApproval && !approvalValid && this.approvalWrap) {
        this.approvalWrap.classList.remove('is-alerting');
        void this.approvalWrap.offsetWidth;
        this.approvalWrap.classList.add('is-alerting');
        this.approval.focus({ preventScroll:true });
        this.approvalWrap.scrollIntoView({ behavior:'smooth', block:'center' });
      }
      const status = this.querySelector('.tss-qp__status');
      if (status && !valid) status.textContent = !textValid ? 'Please enter the wording you want on your sign.' : this.requireHoles && !holesValid ? 'Please choose a hole placement option.' : this.requireApproval && !approvalValid ? 'Please approve your selection before adding the sign to your cart.' : 'Please complete all required selections.';
    }
    return valid;
  }

  isCustomized() { return Boolean(this.customizeToggle?.checked); }

  displayText() {
    const raw = this.textInput?.value || '';
    return this.forceUppercase ? raw.toUpperCase() : raw;
  }

  async loadChickenFont() {
    if (this.chickenFontLoaded) return true;
    if (!this.chickenFontUrl) {
      this.chickenFontLoaded = document.fonts?.check?.(`100px "${this.chickenFontFamily}"`) || false;
      document.fonts?.ready?.then(() => this.fitText());
      return this.chickenFontLoaded;
    }
    if (this.chickenFontPromise) return this.chickenFontPromise;
    this.chickenFontPromise = (async () => {
      try {
        const face = new FontFace(this.chickenFontFamily, `url(${JSON.stringify(this.chickenFontUrl)})`, { style:'normal', weight:'400' });
        const loaded = await face.load();
        document.fonts.add(loaded);
        await document.fonts.load(`100px "${this.chickenFontFamily}"`);
        this.chickenFontLoaded = document.fonts.check(`100px "${this.chickenFontFamily}"`);
        this.fitText();
        this.scheduleProofPreview();
        return this.chickenFontLoaded;
      } catch (error) {
        this.chickenFontLoaded = false;
        console.warn('Chicken listing font could not be loaded:', error);
        return false;
      }
    })();
    return this.chickenFontPromise;
  }

  syncCustomizationMode() {
    const custom = this.isCustomized();
    this.classList.toggle('is-customizing', custom);
    this.previewWrap?.classList.toggle('has-personalized-text', custom);
    if (this.customTextField) this.customTextField.hidden = !custom;
    if (this.textInput) {
      this.textInput.disabled = !custom;
      this.textInput.required = custom;
      if (custom && !this.textInput.value.trim()) this.textInput.value = this.textInput.dataset.defaultCustomText || '';
    }
    if (this.customizationProperty) this.customizationProperty.value = custom ? this.customDesignLabel : this.originalDesignLabel;
    if (!custom) {
      this.assetsReady = true;
      const proof = this.querySelector('[data-qp-proof-url]'); if (proof) proof.value='';
      const print = this.querySelector('[data-qp-print-url]'); if (print) print.value='';
      const dpi = this.querySelector('[data-qp-print-dpi]'); if (dpi) dpi.value='';
      const design = this.querySelector('[data-qp-design-id]'); if (design) design.value='';
      if (this.proofCard) this.proofCard.hidden = true;
    } else {
      this.assetsReady = false;
    }
    this.syncText();
    this.updateReview();
    this.updateStepButtons();
    this.updateRequiredNotice();
  }

  renderNormalizedPreviewText(text) {
    if (!this.previewText) return;
    this.previewText.style.setProperty('--qp-letter-fill', `${this.letterFillStrength / 100}em`);
    this.previewText.replaceChildren();
    [...text].forEach((char) => {
      const span = document.createElement('span');
      span.className = 'tss-chicken-char';
      span.textContent = char === ' ' ? ' ' : char;
      this.previewText.append(span);
    });
  }

  syncAll() { this.syncCustomizationMode(); this.syncFont(); this.syncHoles(); this.setTextColor(this.textColor?.value || '#1c1c1c'); this.syncDoubleSided(); this.syncPrice(); this.validateForm(); this.updateReview(); }
  syncText() {
    const value = this.textInput?.value || '';
    const display = this.displayText();
    if (this.count) this.count.textContent = `${value.length}/${this.textInput?.maxLength || 0}`;
    if (this.isCustomized()) this.renderNormalizedPreviewText(display || this.textInput?.placeholder || 'YOUR CUSTOM TEXT');
    this.fitText();
    if (this.isCustomized() && value.trim()) this.scheduleProofPreview();
    this.updateReview();
    this.updateStepButtons();
  }
  syncFont() {
    if (this.preview) this.preview.style.setProperty('--qp-font', `'${this.chickenFontFamily}'`);
    this.fitText();
    if (this.isCustomized()) this.scheduleProofPreview();
    this.updateReview();
  }
  syncHoles() {
    const chosen = this.querySelector('[data-qp-holes]');
    const holeMap = {'Four corner holes':'corners','Two top holes':'top','Top and bottom center holes':'top-bottom','Left and right center holes':'left-right'};
    this.preview.dataset.holes = holeMap[chosen?.value] || 'none';
    this.updateReview();
  }
  setTextColor(color) {
    if (!/^#[0-9a-f]{6}$/i.test(color || '')) return;
    this.preview.style.setProperty('--qp-text-color', color);
    this.previewText.style.color = color;
    const label = this.querySelector('[data-qp-text-color-label]');
    const property = this.querySelector('[data-qp-text-color-property]');
    if (label) label.textContent = color.toUpperCase();
    if (property) property.value = color.toUpperCase();
    if (this.isCustomized()) this.scheduleProofPreview();
  }
  doubleSidedAddon() {
    if (!this.doubleSided?.checked || !this.currentDimensions) return 0;
    const area = this.currentDimensions.width * this.currentDimensions.height;
    return area <= 215 ? 1000 : area <= 552 ? 2000 : 3000;
  }
  syncDoubleSided() {
    const addon = this.doubleSidedAddon();
    const label = this.querySelector('[data-qp-double-label]');
    const property = this.querySelector('[data-qp-double-price]');
    if (label) label.textContent = this.doubleSided?.checked ? `Adds ${this.formatMoney(addon)} per sign` : 'Select to print both sides';
    if (property) property.value = this.formatMoney(addon);
    this.updateReview();
  }
  syncVariant(id) {
    const variant = this.variantData.find((item) => String(item.id) === String(id));
    if (!variant) return;
    this.form.querySelector('[name="id"]').value = variant.id;
    this.dataset.basePrice = variant.price;
    const price = this.querySelector('[data-qp-heading-price]');
    if (price) price.textContent = this.formatMoney(variant.price);
    this.variantAvailable = Boolean(variant.available);
    this.submit.textContent = variant.available ? this.submit.dataset.availableText : this.submit.dataset.soldoutText;
    const dimensions = String(variant.title || '').match(/([0-9.]+)\s*(?:\"|in)?\s*[x×]\s*([0-9.]+)/i);
    const variantAspect = dimensions ? Number(dimensions[2]) / Number(dimensions[1]) : Number(variant.aspect || 0);
    if (variantAspect > 0) this.preview.style.setProperty('--qp-aspect', variantAspect);
    if (dimensions) this.updateHoleGeometry(Number(dimensions[1]), Number(dimensions[2]));
    this.assetsReady = false;
    if (this.isCustomized()) this.scheduleProofPreview();
    this.fitText();
    this.syncPrice();
    this.validateForm();
    this.updateReview();
  }

  scheduleProofPreview() {
    this.assetsReady = false;
    clearTimeout(this.proofTimer);
    this.proofTimer = setTimeout(async () => {
      if (!this.isCustomized() || !this.textInput?.value.trim() || !this.currentDimensions) return;
      try {
        const proof = await this.renderArtwork('proof');
        if (this.proofPreview) this.proofPreview.src = proof.dataUrl;
        if (this.proofCard) this.proofCard.hidden = false;
      } catch (_error) {}
    }, 350);
  }

  async handleAddToCart() {
    if (!this.validateForm(true) || this.isSubmitting) return;
    if (!this.isCustomized()) {
      this.assetsReady = true;
      if (this.customizationProperty) this.customizationProperty.value = this.originalDesignLabel;
      this.form.requestSubmit();
      return;
    }
    if (!this.stageEndpoint || !this.finalizeEndpoint) {
      this.setStatus('Production file storage is not configured. Please contact us for help.');
      return;
    }
    const fontReady = await this.loadChickenFont();
    if (this.chickenFontUrl && !fontReady) {
      this.setStatus('The listing font did not finish loading. Please refresh the page and try again.');
      return;
    }
    this.isSubmitting = true;
    const originalLabel = this.submit.textContent;
    this.submit.setAttribute('aria-disabled','true');
    try {
      this.setStatus('Creating your proof…');
      this.submit.textContent = 'Preparing your sign…';
      await document.fonts?.ready;
      const designId = `QP-${Date.now()}-${Math.random().toString(36).slice(2,7).toUpperCase()}`;
      const proof = await this.renderArtwork('proof');
      if (this.proofPreview) this.proofPreview.src = proof.dataUrl;
      if (this.proofCard) this.proofCard.hidden = false;
      const proofUrl = await this.uploadArtwork(proof.blob, `${designId}-proof.jpg`, 'image/jpeg', `Quick Personalizer proof · ${proof.width} × ${proof.height}px`);

      this.setStatus('Creating the high-resolution printing file…');
      const print = await this.renderArtwork('print');
      const printUrl = await this.uploadArtwork(print.blob, `${designId}-print-${print.dpi}dpi.png`, 'image/png', `Quick Personalizer production file · ${print.width} × ${print.height}px · ${print.dpi} DPI`);

      this.querySelector('[data-qp-proof-url]').value = proofUrl;
      this.querySelector('[data-qp-print-url]').value = printUrl;
      this.querySelector('[data-qp-print-dpi]').value = String(print.dpi);
      this.querySelector('[data-qp-design-id]').value = designId;
      this.assetsReady = true;
      this.setStatus('Your proof and production file are ready. Adding your sign to the cart…');
      this.form.requestSubmit();
    } catch (error) {
      console.error('Quick Personalizer file preparation failed:', error);
      this.setStatus(error?.message || 'We could not prepare the printing file. Please try again.');
      this.submit.textContent = originalLabel;
      this.submit.setAttribute('aria-disabled','false');
      this.isSubmitting = false;
    }
  }

  setStatus(message) {
    const status = this.querySelector('.tss-qp__status');
    if (status) status.textContent = message;
  }

  async loadBackground() {
    if (this.backgroundImage) return this.backgroundImage;
    this.backgroundImage = await new Promise((resolve,reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('The product background could not be loaded for printing.'));
      image.src = this.backgroundUrl;
    });
    return this.backgroundImage;
  }

  async renderArtwork(kind) {
    const dimensions = this.currentDimensions;
    if (!dimensions) throw new Error('Please choose a standard sign size.');
    const maxEdge = 15000;
    const maxPixels = 40000000;
    let dpi;
    if (kind === 'print') {
      dpi = Math.max(150, Math.min(300, Math.floor(maxEdge / Math.max(dimensions.width, dimensions.height)), Math.floor(Math.sqrt(maxPixels / (dimensions.width * dimensions.height)))));
    } else {
      dpi = Math.min(1200 / dimensions.width, 500 / dimensions.height);
    }
    const width = Math.max(1, Math.round(dimensions.width * dpi));
    const height = Math.max(1, Math.round(dimensions.height * dpi));
    const canvas = document.createElement('canvas');
    canvas.width = width; canvas.height = height;
    const context = canvas.getContext('2d', { alpha:false });
    const background = await this.loadBackground();
    const sourceRatio = background.naturalWidth / background.naturalHeight;
    const targetRatio = width / height;
    let sx=0,sy=0,sw=background.naturalWidth,sh=background.naturalHeight;
    if (sourceRatio > targetRatio) { sw = sh * targetRatio; sx = (background.naturalWidth - sw) / 2; }
    else { sh = sw / targetRatio; sy = (background.naturalHeight - sh) / 2; }
    context.drawImage(background,sx,sy,sw,sh,0,0,width,height);
    this.drawCanvasText(context,width,height);
    const type = kind === 'print' ? 'image/png' : 'image/jpeg';
    const blob = await new Promise((resolve) => canvas.toBlob(resolve,type,kind === 'print' ? undefined : .88));
    if (!blob) throw new Error('The personalized artwork could not be generated.');
    return { blob, width, height, dpi:kind === 'print' ? dpi : null, dataUrl:kind === 'proof' ? canvas.toDataURL('image/jpeg',.82) : null };
  }

  drawCanvasText(context,width,height) {
    const text = this.displayText();
    if (!text) return;
    const family = `"${this.chickenFontFamily}"`;
    const maxWidth = width * (this.maxTextWidthPct / 100);
    const baseSize = height * (this.startTextHeightPct / 100);
    const measureAt = 100;
    context.textBaseline = 'alphabetic';
    context.textAlign = 'left';
    context.fillStyle = getComputedStyle(this.previewText).color;
    context.font = `400 ${measureAt}px ${family}`;
    const letterSpaceAt100 = measureAt * (this.letterSpacing / 100);
    const widthsAt100 = [...text].map((char) => context.measureText(char).width);
    const totalAt100 = widthsAt100.reduce((sum,v)=>sum+v,0) + Math.max(0,text.length-1)*letterSpaceAt100;
    const widthFit = totalAt100 > 0 ? maxWidth * measureAt / totalAt100 : baseSize;
    const fontSize = Math.max(12, Math.min(baseSize, widthFit));
    const spacing = fontSize * (this.letterSpacing / 100);
    context.font = `400 ${fontSize}px ${family}`;
    const metrics = context.measureText('HMX');
    const ascent = metrics.actualBoundingBoxAscent || fontSize * .76;
    const descent = metrics.actualBoundingBoxDescent || fontSize * .18;
    const visualMiddleCorrection = (ascent - descent) / 2;
    const centerY = height * (this.textYPct / 100);
    const baselineY = centerY + visualMiddleCorrection;
    this.drawSpacedLine(context,text,width/2,baselineY,spacing);
  }

  drawSpacedLine(context,text,centerX,y,spacing) {
    const chars = [...text];
    const widths = chars.map(char => context.measureText(char).width);
    const total = widths.reduce((sum,value)=>sum+value,0)+Math.max(0,widths.length-1)*spacing;
    const fontSizeMatch = String(context.font || '').match(/([0-9.]+)px/);
    const fontSize = fontSizeMatch ? Number(fontSizeMatch[1]) : 0;
    const fillStroke = Math.max(0, fontSize * (this.letterFillStrength / 100));
    context.save();
    context.strokeStyle = context.fillStyle;
    context.lineWidth = fillStroke;
    context.lineJoin = 'round';
    context.lineCap = 'round';
    let x=centerX-total/2;
    chars.forEach((char,index)=>{
      if (fillStroke > 0 && char.trim()) context.strokeText(char,x,y);
      context.fillText(char,x,y);
      x+=widths[index]+spacing;
    });
    context.restore();
  }

  async uploadArtwork(blob,filename,mimeType,alt) {
    const stagedResponse = await fetch(this.stageEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({filename,mimeType})});
    const staged = await stagedResponse.json().catch(()=>({}));
    if (!stagedResponse.ok || staged.error || !staged.uploadUrl) throw new Error(staged.error || 'Could not prepare the file upload.');
    let uploadResponse;
    if (staged.uploadMethod === 'raw') {
      uploadResponse = await fetch(staged.uploadUrl,{method:'POST',headers:{'Content-Type':'application/octet-stream'},body:blob});
    } else {
      const form = new FormData();
      for (const parameter of (staged.parameters || [])) form.append(parameter.name,parameter.value);
      form.append('file',blob,staged.filename || filename);
      uploadResponse = await fetch(staged.uploadUrl,{method:'POST',body:form});
    }
    if (!uploadResponse.ok) {
      const uploadDetail = await uploadResponse.text().catch(() => '');
      throw new Error(`The personalized file upload did not finish (${uploadResponse.status})${uploadDetail ? `: ${uploadDetail.slice(0,300)}` : ''}`);
    }
    const finalResponse = await fetch(this.finalizeEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({resourceUrl:staged.resourceUrl,alt})});
    const finalized = await finalResponse.json().catch(()=>({}));
    if (!finalResponse.ok || finalized.error || !finalized.url) throw new Error(finalized.error || 'Production storage could not save the personalized file.');
    return finalized.url;
  }
  updateHoleGeometry(heightInches, widthInches) {
    if (!(heightInches > 0 && widthInches > 0)) return;
    this.currentDimensions = { height:heightInches, width:widthInches };
    // Keep hole centers outside the 4% x / 8% y text-safe boundary.
    const insetInches = .25;
    this.preview.style.setProperty('--qp-hole-x', `${Math.min(16, insetInches / widthInches * 100)}%`);
    this.preview.style.setProperty('--qp-hole-y', `${Math.min(22, insetInches / heightInches * 100)}%`);
    const pixelsPerInch = Math.min(this.preview.clientWidth / widthInches, this.preview.clientHeight / heightInches);
    this.preview.style.setProperty('--qp-hole-size', `${Math.max(5, Math.min(13, pixelsPerInch * .25))}px`);
  }
  getTier(quantity) {
    if (quantity >= 20) return { discount:.50, label:'50% bulk savings applied' };
    if (quantity >= 15) return { discount:.40, label:'40% bulk savings applied' };
    if (quantity >= 10) return { discount:.35, label:'35% bulk savings applied' };
    if (quantity >= 6) return { discount:.30, label:'30% bulk savings applied' };
    if (quantity >= 4) return { discount:.25, label:'25% bulk savings applied' };
    if (quantity >= 2) return { discount:.20, label:'20% bulk savings applied' };
    return { discount:0, label:'Add one more sign to save 20%' };
  }
  getTierMessage(quantity, tier) {
    const thresholds = [
      { quantity:2, discount:20 }, { quantity:4, discount:25 }, { quantity:6, discount:30 },
      { quantity:10, discount:35 }, { quantity:15, discount:40 }, { quantity:20, discount:50 }
    ];
    const next = thresholds.find((item) => item.quantity > quantity);
    if (!next) return 'You unlocked our highest bulk discount: 50% off.';
    const needed = next.quantity - quantity;
    const prompt = `Add ${needed === 1 ? 'one more sign' : `${needed} more signs`} to unlock ${next.discount}% off.`;
    return tier.discount ? `${Math.round(tier.discount * 100)}% bulk savings applied. ${prompt}` : prompt;
  }
  syncPrice() {
    const qty = Math.max(1, Number(this.quantity?.value || 1));
    const base = Number(this.dataset.basePrice || 0);
    const tier = this.getTier(qty);
    const addon = this.doubleSidedAddon();
    const unitBeforeDiscount = base + addon;
    const unit = Math.round(unitBeforeDiscount * (1 - tier.discount));
    if (this.unitPrice) this.unitPrice.textContent = `${this.formatMoney(unit)} each`;
    if (this.totalPrice) this.totalPrice.value = this.formatMoney(unit * qty);
    const discountProperty = this.querySelector('[data-qp-bulk-discount]');
    const subtotalProperty = this.querySelector('[data-qp-bulk-subtotal]');
    const unitProperty = this.querySelector('[data-qp-bulk-unit]');
    if (discountProperty) discountProperty.value = tier.discount ? `${Math.round(tier.discount * 100)}% bulk savings` : 'None';
    if (subtotalProperty) subtotalProperty.value = this.formatMoney(unitBeforeDiscount * qty);
    if (unitProperty) unitProperty.value = this.formatMoney(unit);
    if (this.tierMessage) this.tierMessage.textContent = this.getTierMessage(qty, tier);
    const headingPrice = this.querySelector('[data-qp-heading-price]');
    if (headingPrice) headingPrice.textContent = this.formatMoney(unit * qty);
    this.syncDoubleSided();
    this.updateReview();
  }
  fitText() {
    if (!this.previewText || !this.preview || !this.isCustomized()) return;
    const text = this.displayText() || this.textInput?.placeholder || 'YOUR CUSTOM TEXT';
    const styles = getComputedStyle(this.previewText);
    const canvas = this._measureCanvas || (this._measureCanvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    const measureAt = 100;
    context.font = `400 ${measureAt}px "${this.chickenFontFamily}"`;
    const chars = [...text];
    const spacingAt100 = measureAt * (this.letterSpacing / 100);
    const measured = chars.map((char)=>context.measureText(char).width).reduce((sum,value)=>sum+value,0) + Math.max(0,chars.length-1)*spacingAt100;
    const maxWidth = Math.max(1, this.preview.clientWidth * (this.maxTextWidthPct / 100));
    const baseSize = Math.max(12, this.preview.clientHeight * (this.startTextHeightPct / 100));
    const widthFit = measured > 0 ? maxWidth * measureAt / measured : baseSize;
    const size = Math.max(12, Math.min(baseSize, widthFit));
    this.previewText.style.fontSize = `${size}px`;
    this.previewText.style.top = `${this.textYPct}%`;
    this.previewText.style.width = `${this.maxTextWidthPct}%`;
    this.previewText.style.letterSpacing = `${this.letterSpacing / 100}em`;
    this.previewText.style.fontFamily = `"${this.chickenFontFamily}"`;
    this.previewText.style.setProperty('--qp-letter-fill', `${this.letterFillStrength / 100}em`);
    this.previewText.style.fontFeatureSettings = '"liga" 0, "clig" 0, "dlig" 0';
    this.previewText.style.fontVariantLigatures = 'none';
  }

  formatMoney(cents) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return this.moneyFormat.replace('{{amount}}', value).replace('{{ amount }}', value);
  }
}
if (!customElements.get('tss-chicken-personalizer')) customElements.define('tss-chicken-personalizer', TSSChickenQuickPersonalizer);
